import { getScrollParent, isPassiveEventsSupported, isRootHTMLElement } from './utils';
var LISTENER_OPTIONS = isPassiveEventsSupported() ? { passive: false } : undefined;
var state = {
    count: 0,
    lastX: 0,
    lastY: 0,
    scrollable: null,
    scrollX: 0,
    scrollY: 0,
};
function onTouchStart(event) {
    if (event.changedTouches.length === 1) {
        state.scrollable = getScrollParent(event.target);
        if (isRootHTMLElement(state.scrollable)) {
            return;
        }
        state.lastX = event.changedTouches[0].pageX;
        state.lastY = event.changedTouches[0].pageY;
    }
}
function onTouchMove(event) {
    var scrollable = state.scrollable, lastX = state.lastX, lastY = state.lastY;
    if (event.changedTouches.length > 1) {
        return;
    }
    if (!scrollable || isRootHTMLElement(scrollable)) {
        event.preventDefault();
        return;
    }
    var x = event.changedTouches[0].pageX;
    var y = event.changedTouches[0].pageY;
    var isVertical = Math.abs(lastY - y) > Math.abs(lastX - x);
    var top = scrollable.scrollTop;
    var bottom = scrollable.scrollHeight - scrollable.clientHeight;
    var left = scrollable.scrollLeft;
    var right = scrollable.scrollWidth - scrollable.clientWidth;
    var isVertiacalScrolled = isVertical && ((top <= 0 && y > lastY) || (top >= bottom && y < lastY));
    var isHorizontalScrolled = !isVertical && ((left <= 0 && x > lastX) || (left >= right && x < lastX));
    if (isVertiacalScrolled || isHorizontalScrolled) {
        event.preventDefault();
    }
    state.lastX = x;
    state.lastY = y;
}
function onTouchEnd() {
    if (state.scrollable) {
        state.scrollable = null;
    }
}
export function lock(container) {
    if (!isRootHTMLElement(container)) {
        return;
    }
    state.count++;
    if (state.count === 1) {
        state.scrollX = window.pageXOffset;
        state.scrollY = window.pageYOffset;
        document.addEventListener('touchstart', onTouchStart, LISTENER_OPTIONS);
        document.addEventListener('touchmove', onTouchMove, LISTENER_OPTIONS);
        document.addEventListener('touchend', onTouchEnd, LISTENER_OPTIONS);
    }
}
export function unlock(container) {
    if (!isRootHTMLElement(container) || state.count === 0) {
        return;
    }
    state.count--;
    if (state.count === 0) {
        document.removeEventListener('touchstart', onTouchStart);
        document.removeEventListener('touchmove', onTouchMove);
        document.removeEventListener('touchend', onTouchEnd);
        window.scrollTo(state.scrollX, state.scrollY);
    }
}
